import { DocumentNode, gql } from '@apollo/client';
import { LinkOverlay, StackProps } from '@chakra-ui/react';
import NextLink from 'next/link';
import * as React from 'react';

import { GroupListItem_GroupFragment } from './graphql-types/GroupListItem_GroupFragment';

import { Content } from './components/Content';

export const ListItem: React.FC<
  {
    group: GroupListItem_GroupFragment;
    showHiddenTag: boolean;
    href?: string;
    truncateName?: boolean;
    iconSize?: number;
  } & StackProps
> & {
  groupFragment: DocumentNode;
} = ({ showHiddenTag, group, href, truncateName, iconSize, ...stackProps }) => {
  return href ? (
    <LinkOverlay as={NextLink} href={href}>
      <Content
        group={group}
        showHiddenTag={showHiddenTag}
        truncateName={truncateName}
        iconSize={iconSize}
        {...stackProps}
      />
    </LinkOverlay>
  ) : (
    <Content
      group={group}
      showHiddenTag={showHiddenTag}
      truncateName={truncateName}
      iconSize={iconSize}
      {...stackProps}
    />
  );
};
ListItem.groupFragment = gql`
  fragment GroupListItem_GroupFragment on Group {
    _id
    ...GroupListItemContent_GroupFragment
  }
  ${Content.groupFragment}
`;
